import axios from 'axios'
import apiURL from './apiURL.js'
import Vue from 'vue'
import Message from '../components/messageBox'
import Session from '../utils/session'
import '../utils/setUserInfo'

const userId = Session.get("userId")
const service = axios.create({
  headers: {
    'content-type': 'application/json;charset=UTF-8',
    'x-user-id': userId
  },
  baseURL: apiURL.baseURL,
  timeout: 10000,
  withCredentials: true
})


service.interceptors.response.use(
  response => {
    if(response.data.appId || response.data.b64 || response.data.url){
      return response.data;
    }
    if (response.data.code === 1) {
      return response.data;
    } else {
      return Promise.reject(response.data)
    }
  },
  error => {
    if(error.response.status == '401'){
      Vue.$Message({
        content: '没有访问权限'
      })
    }
    return Promise.reject(error)
  }
)
export default service;